import {isSameDashboardScope} from './is-same-dashboard-scope';
import {DashboardScope} from './model/dashboard-scope.model';
import {DashboardScopeOption} from './model/dashboard-scope-option.model';

/**
 * Détermine la cible de restitution à ouvrir.
 *
 * Priorité : celle désignée par l'URL, puis la dernière consultée, puis la première de la liste.
 * Une cible venue d'ailleurs (URL, préférences) n'est retenue que si elle figure encore parmi les
 * cibles accessibles : une enquête supprimée ou retirée des affectations laisse la place à la
 * suivante plutôt que d'ouvrir une restitution vide.
 *
 * @returns la cible retenue, débarrassée de son nom, ou `null` si aucune n'est disponible.
 */
export const resolveDashboardScope = (
    options: DashboardScopeOption[],
    fromUrl: DashboardScope | null,
    working: DashboardScope | null
): DashboardScope | null => {
    const available = (scope: DashboardScope | null): boolean =>
        !!scope && options.some((option) => isSameDashboardScope(option, scope));

    const retained = [fromUrl, working].find(available) ?? options[0] ?? null;

    return retained ? {kind: retained.kind, id: retained.id} : null;
};
